import { render, staticRenderFns } from "./clients-create.vue?vue&type=template&id=28eebfac&scoped=true"
import script from "./clients-create.vue?vue&type=script&lang=js"
export * from "./clients-create.vue?vue&type=script&lang=js"
import style0 from "./clients-create.vue?vue&type=style&index=0&id=28eebfac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eebfac",
  null
  
)

export default component.exports